import Vue from 'vue'
import Vuex from 'vuex'
import landingModule from './landing'
import settingsModule from './settings'
import historyModule from './history'
import uiModule from './ui'
import dashboardModule from './dashboard'
import funnelsModule from './funnels'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    landing: landingModule,
    settings: settingsModule,
    history: historyModule,
    ui: uiModule,
    dashboard: dashboardModule,
    funnels: funnelsModule,
  },
})
